import Vue from 'vue'
import { axios } from '@/utils'

import VueI18n from 'vue-i18n'
import lang_it from '@/lang/it.json'
import lang_en from '@/lang/en.json'
import lang_es from '@/lang/es.json'
import lang_pt from '@/lang/pt.json'
import lang_de from '@/lang/de.json'
import lang_fr from '@/lang/fr.json'
import lang_sl from '@/lang/sl.json'
import lang_ru from '@/lang/ru.json'
import lang_pl from '@/lang/pl.json'

import { Validator } from 'vee-validate'
import * as it from 'vee-validate/dist/locale/it.js'
import * as en from 'vee-validate/dist/locale/en.js'
import * as es from 'vee-validate/dist/locale/es.js'
import * as de from 'vee-validate/dist/locale/de.js'
import * as fr from 'vee-validate/dist/locale/fr.js'
import * as sl from 'vee-validate/dist/locale/sl.js'
import * as pt from 'vee-validate/dist/locale/pt_PT'
import * as ru from 'vee-validate/dist/locale/ru'
import * as pl from 'vee-validate/dist/locale/pl'
import {locale} from "moment";
// import moment from "moment"

// TODO: spostare in main.js?
Vue.use(VueI18n)


const locales = [
    {
        code: 'it',
        name: 'Italiano',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'en',
        name: 'English',
        dir: 'ltr',
        sundayFirstDayWeek: true
    },
    {
        code: 'es',
        name: 'Español',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'pt',
        name: 'Português',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'de',
        name: 'Deutsch',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'fr',
        name: 'Français',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'sl',
        name: 'Slovenščina',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'ru',
        name: 'Pусский',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
    {
        code: 'pl',
        name: 'Polski',
        dir: 'ltr',
        sundayFirstDayWeek: false
    },
]


const getBrowserLanguage = function () {
    return navigator.language.includes('-') ? navigator.language.split('-')[0] : navigator.language
}

const getLocaleConf = function (code) {
    let localeConf = locales.find((e) => e.code === code)
    if(!localeConf){
        localeConf =  locales.find((e) => e.code === 'en')
    }
    return localeConf

}

const setI18nLanguage = function (lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    switch (lang) {
        case 'it':
            Validator.localize('it', it)
            break
        case 'en':
            Validator.localize('en', en)
            break
        case 'es':
            Validator.localize('es', es)
            break
        case 'pt':
            Validator.localize('pt', pt)
            break
        case 'de':
            Validator.localize('de', de)
            break
        case 'fr':
            Validator.localize('fr', fr)
            break
        case 'sl':
            Validator.localize('sl', sl)
            break
        case 'ru':
            Validator.localize('ru', ru)
            break
        case 'pl':
            Validator.localize('pl', pl)
            break
        default:
            break
    }

    // TODO: moment.locale(lang)
    return lang
}


const i18n = new VueI18n({
    locale: getBrowserLanguage(),
    fallbackLocale: 'en',
    messages: {it: lang_it, en: lang_en, es: lang_es, pt: lang_pt, de: lang_de, fr: lang_fr, sl: lang_sl, ru: lang_ru, pl: lang_pl}
})



export { locales, getBrowserLanguage, setI18nLanguage, getLocaleConf, i18n }
